import { observer } from 'mobx-react';
import { FC, ReactElement, useEffect } from 'react';
import ManageFAQList from './containers/ManageFAQList/ManageFAQList';
import ManageFAQListHeader from './containers/ManageFAQListHeader/ManageFAQListHeader';
import manageFAQStore from './store/manageFAQStore';

const ManageFAQScreen: FC = observer((): ReactElement => {
  useEffect(() => {
    return () => manageFAQStore.unMount();
  }, []);

  return (
    <div className="d-flex flex-column full-width flex-grow-1">
      <ManageFAQListHeader />
      <ManageFAQList />
    </div>
  );
});

export default ManageFAQScreen;
